import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Fish from '@sdi/fish';
import './base.css';
import '@sdi/fish/lib/index.css';
import '@/assets/icons/iconfont.js';

Vue.use(Fish);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
